import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white mt-4 relative z-0 w-full">
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-lg font-semibold mb-4">eHandshake</h3>
            <p className="text-gray-400">Connecting local businesses in your neighborhood with AI powered solutions.</p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li className="text-gray-400">Email: Support@ehandshake.com</li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Email: customerservice@ehandshake.com</li>
              <li>Phone: +1 (832)301-0290</li>
              <li><a href="/privacy" className="text-gray-400 hover:text-white">Privacy Policy</a></li>
              <li><a href="/terms" className="text-gray-400 hover:text-white">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} eHandshake. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;